<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ !formData.id ? $t('global.menu.backoffice.createStreamCategory') :
                    $t('global.menu.backoffice.editStreamCategory') }}
            </h3>
        </template>

        <template #default>
            <v-form ref="form">
                <v-row class="shop-info-container">
                    <!-- Linke Spalte: Basisinformationen -->
                    <v-col cols="12" md="6">

                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.name" density="compact" maxlength="30" counter
                                    hide-details="auto" :rules="nameRules" @input="formData.name = formData.name.replace(/[^A-Za-z0-9]/g, '')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.shortname-de') }}
                                    <v-tooltip>
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small"
                                                @click="() => openDialog(feature)">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('global.menu.backoffice.hintshortNameStreamCategory') }}</span><br>
                                    </v-tooltip>
                                </v-label>
                                <v-text-field variant="outlined" v-model="formData.shortNames.de" density="compact"
                                    hide-details="auto" :rules="nameDERules" maxlength="100" counter></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.description-de') }}</v-label>
                                <v-textarea no-resize rows="2" variant="outlined" v-model="formData.descriptions.de"
                                    density="compact" :hide-details="true" :rules="descriptionDERules"></v-textarea>
                            </v-col>
                        </v-row>


                    </v-col>
                    <v-col cols="12" md="6">

                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.sortOrder') }}
                                    <v-tooltip>
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('global.menu.backoffice.hintSortOrderStreamCategory')}}</span><br>
                                    </v-tooltip>
                                </v-label>
                                <v-text-field variant="outlined" v-model="formData.sortOrder" density="compact"
                                    :hide-details="false"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.shortname-en') }}
                                    <v-tooltip>
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small"
                                                @click="() => openDialog(feature)">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('global.menu.backoffice.hintshortNameStreamCategory') }}</span><br>
                                    </v-tooltip>
                                </v-label>
                                <v-text-field variant="outlined" v-model="formData.shortNames.en" density="compact"
                                    hide-details="auto" :rules="nameENRules" maxlength="100" counter></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.description-en') }}</v-label>
                                <v-textarea no-resize rows="2" variant="outlined" v-model="formData.descriptions.en"
                                    density="compact" :hide-details="true" :rules="descriptionENRules"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" >
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.imageUrl') }}
                                    <v-tooltip>
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('global.menu.backoffice.hintImageUrlStreamCategory')}}</span><br>
                                    </v-tooltip>
                                </v-label>
                                <v-text-field variant="outlined" v-model="formData.imageUrl" density="compact"
                                    :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="formData.imageId == null">
                            <v-col cols="4">
                                <v-label class="mr-4">{{ $t('global.form.image') }}</v-label>
                                <cropper ref="cropper" class="cropper" :src="selectedImage.src"
                                    v-if="selectedImage.src" :stencil-props="{
                                        movable: true,
                                        resizable: true
                                    }" />
                                    <v-img v-else-if="isGif && previewSrc != null" aspect-ratio="16/9" cover class="mb-2"
                                :src="previewSrc"></v-img>
                                    <v-img v-else-if="!isGif && image != null" aspect-ratio="16/9" cover class="mb-2"
                                :src="image"></v-img>
                                <v-sheet width="100%" height="160px" color="#e4e4e4" class="pa-8" v-else>
                                </v-sheet>
                            </v-col>
                            <v-col cols="4">
                                <v-row class="mt-3">
                                    <v-col align-self="end">
                                        <v-btn size="large" variant="flat" color="default" rounded="xl"
                                            @click="triggerFileSelect" v-if="!selectedImage.src">{{
                                                $t('entity.action.chooseGalleryImage') }}</v-btn>
                                        <v-btn size="large" variant="flat" color="default" rounded="xl"
                                            @click="resetImage" v-else>{{
                                            $t('entity.action.cancel') }}</v-btn>
                                        <input type="file" accept="image/*" ref="fileInput" style="display: none;"
                                            @change="handleFileChange" />
                                    </v-col>
                                </v-row>
                                
                                <v-row class="mt-1" justify="between" v-if="selectedImage.src">
                                    <v-col align-self="end">
                                        <v-btn class="" size="large" variant="flat" color="primary" rounded="xl"
                                @click="addImage" >Zuschneiden und Speichern</v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <v-row class="mt-1" justify="between" v-else>
                                    <v-col align-self="end">
                                        <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large"
                                            prepend-icon="mdi-plus" color="primary" @click="addImage">{{
                                                $t('entity.action.upload') }}</v-btn>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="4">
                                <v-label class="mr-4">{{ $t('global.form.image') }}</v-label>
                                <v-img width="100%" height="160px" aspect-ratio="16/9" cover class="mb-2"
                                            :src="`${cloudfrontUrl}${formData.imageId}/ORIGINAL`"><v-icon color="error" class="float-right" @click.stop="() => removeImage(formData.imageId)">
                                            mdi-trash-can
                                        </v-icon></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- {{ formData }} -->
                </v-row>

            </v-form>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="validate">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {

    name: "CreateLabelCategoryDialog",
    components: {
        Cropper, CircleStencil
    },


    data() {
        return {
            cloudfrontUrl: process.env.VUE_APP_CLOUDFRONT_BASE_URL
        }
    },

    methods: {
        getCroppedData() {
            console.log(this.$refs);
            console.log(this.$refs.cropper);
            const { coordinates, canvas, } = this.$refs.cropper.getResult();
            return { coordinates, canvas, }
        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';


const { proxy } = getCurrentInstance()
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ shortNames: {de:"",en:""},descriptions:{de:"",en:""},imageId:null }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const form = ref(null)
const props = defineProps({
    save: Function, // Define prop as a function
});


// watch(
//     () => formData.value?.translations?.DE?.value, // Safe access using optional chaining
//     (newValue) => {
//         if (newValue !== undefined) {
//             formData.value.name = newValue; // Update name
//         }
//     },
//     { deep: true } // Optional: If translations can be updated dynamically
// );
watch(formData, (newValue) => {
    if (!newValue) {
        formData.value = { shortNames: {de:"",en:""},descriptions:{de:"",en:""},imageId:null };
    }
});
watch(dialogVisible, (newValue) => {
    if (!newValue) {
        formData.value = { shortNames: {de:"",en:""},descriptions:{de:"",en:""},imageId:null };
        image.value = null;
    }
});

const nameRules = [
  v => !!v || 'Name ist erforderlich',
  v => (v && v.length <= 30) || 'Maximal 30 Zeichen erlaubt',
];
const nameDERules = [
  v => !!v || 'shortName ist erforderlich',
  v => (v && v.length <= 100) || 'Maximal 100 Zeichen erlaubt',
];

const nameENRules = [
    v => !!v || 'Name(English) is required',
    v => (v && v.length >= 3) || 'Name(English) must be at least 3 characters',
];
const frontendIdRules = [
    v => !!v || 'frontendId is required',
    v => (v && v.toString().length >= 1) || 'frontendId must be at least 1 digit.',
]
const validate = async () => {
    const { valid, errors } = await form.value.validate()
    if (!valid) {
        let errorMessages = [];
        Object.values(errors).forEach(fieldErrors => {
            if (fieldErrors.errorMessages.length) {
                errorMessages.push(...fieldErrors.errorMessages);
            }
        });
        errorMessages.forEach(msg => {
            if (msg.length) {
                proxy.$toast.error(msg, { theme: "colored" });
            }
        })
         
        return;
    }
    props.save();
}


const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = { shortNames: {de:"",en:""},descriptions:{de:"",en:""},imageId:null };
    image.value = null;
}
onMounted(() => {

});
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");
const fileInput = ref(null);

const selectedImage = ref({
    src: null,
    width: 80,
    height: 80,
    transforms: {
        rotate: 15,
        flip: {
            horizontal: true,
            vertical: false,
        },
    },
});
const resetImage = () => {
    if (previewSrc.value) URL.revokeObjectURL(previewSrc.value);
  previewSrc.value = null;
  isGif.value = false;
    selectedImage.value = {
        src: null,
        width: 80,
        height: 80,
        transforms: {
            rotate: 15,
            flip: {
                horizontal: true,
                vertical: false,
            },
        },
    }
}


const addImage = async () => {
  if (!isGif.value) {
    cropImage(); // sets saveableLogo.value
  }

  if (!saveableFile.value) {
    console.error("No file selected.");
    return;
  }

  // Build coordinates
  let coords;
  if (isGif.value) {
    // fall back to probing dimensions if not set yet
    const ensureDims = async () => {
      if (gifNaturalSize.value.width > 0 && gifNaturalSize.value.height > 0) return gifNaturalSize.value;
      // probe dimensions via an object URL
      const tmpUrl = URL.createObjectURL(saveableFile.value);
      const dims = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => { resolve({ width: img.naturalWidth, height: img.naturalHeight }); URL.revokeObjectURL(tmpUrl); };
        img.onerror = reject;
        img.src = tmpUrl;
      });
      gifNaturalSize.value = dims;
      return dims;
    };

    const dims = await ensureDims();
    coords = { left: 0, top: 0, width: dims.width, height: dims.height };
  } else {
    coords = saveableLogo.value?.coordinates;
  }

  // Ensure positive integers
  const x = Math.max(0, Math.floor(coords.left || 0));
  const y = Math.max(0, Math.floor(coords.top || 0));
  const width = Math.max(1, Math.floor(coords.width || 0));
  const height = Math.max(1, Math.floor(coords.height || 0));

  try {
    const formDataImage = new FormData();
    formDataImage.append("file", saveableFile.value);
    formDataImage.append("x", String(x));
    formDataImage.append("y", String(y));
    formDataImage.append("width", String(width));
    formDataImage.append("height", String(height));

    const res = await fetch(process.env.VUE_APP_API_BASE_URL + "/image/streamcategory", {
      method: "POST",
      body: formDataImage,
      headers: {
        "X-Auth-HARDTOKEN": hardToken,
        "X-Auth-SOFTTOKEN": softToken,
        "X-Auth-USER": username,
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Upload failed (${res.status}): ${text}`);
    }

    const payload = await res.json();
    // adjust to your actual response shape
    formData.value.imageId = payload?.data ?? payload?.imageId ?? null;
  } catch (err) {
    console.error("Error uploading image:", err);
    proxy.$toast?.error?.(String(err), { theme: "colored" });
  }
};

const image = ref(null)

const saveableLogo = ref(null)

// Trigger the hidden file input
const triggerFileSelect = () => {
    fileInput.value.click();
};
const cropImage = () => {
    saveableLogo.value = proxy.getCroppedData()
    // image.value = saveableLogo.value.canvas.toDataURL();
    if (!isGif.value) {
    // OK to use canvas preview for non-GIFs
        image.value = saveableLogo.value.canvas.toDataURL();
    } else {
        // For GIFs, skip canvas preview to avoid losing animation
        image.value = null;
    }
    resetImage();
}

// Handle the file selection
const previewSrc = ref(null);
const isGif = ref(false);
const saveableFile = ref(null);
const gifNaturalSize = ref({ width: 0, height: 0 });

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  saveableFile.value = file;
  isGif.value = file.type === 'image/gif';

  const url = URL.createObjectURL(file);
  previewSrc.value = url;

  if (!isGif.value) {
    const reader = new FileReader();
    reader.onload = (e) => { selectedImage.value.src = e.target.result; };
    reader.readAsDataURL(file);
  } else {
    selectedImage.value.src = null;

    // get the GIF’s intrinsic dimensions without using canvas
    const img = new Image();
    img.onload = () => {
      gifNaturalSize.value = { width: img.naturalWidth, height: img.naturalHeight };
      // don't revoke previewSrc here; you use it for the preview <v-img>
    };
    img.src = url;
    addImage();
  }

  fileInput.value.value = '';
};

const convertToBlob = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = () => {
            const blob = new Blob([reader.result], { type: file.type });
            resolve(blob);
        };
        reader.onerror = (error) => reject(error);
    });
};

const removeImage = async (id) => {
    try {
        const response = await proxy.$axios.delete(`/image/streamcategory/${id}`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });
        if (response.status == 200) {
            formData.value.imageId = null;
        }
    } catch (error) {
        console.error("Error deleting Obj:", error);
    }
}
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
